<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-map-marked-alt" aria-hidden="true"></i></span>{{ 'AssignmentDistrictMaintenance.Header' | translate}}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [(selected)]="isSearchFormOpen">

        <!-------------------------------------- Query Form ---------------------------------------------->
        <form [formGroup]="searchFormGroup" (ngSubmit)="searchBtnClick()">
          <div class="p-fluid formgrid grid">

            <!-------------------------------------- Assignment District ID slot ---------------------------------------------->
            <div class="col-6 field">
              <label for="formAssignmentDistrictId">{{ 'AssignmentDistrictMaintenance.Form.AssignmentDistrictId' | translate }}</label>
              <input pInputText type="text" maxlength="10" id="formAssignmentDistrictId" formControlName="assignmentDistrictId"/>
            </div>

            <!-------------------------------------- District Name slot ---------------------------------------------->
            <div class="col-6 field">
              <label for="formDistrictName">{{ 'AssignmentDistrictMaintenance.Form.DistrictName' | translate }}</label>
              <input pInputText type="text" maxlength="50" id="formDistrictName" formControlName="districtName"/>
            </div>

            <!-------------------------------------- Location Dropdown ---------------------------------------------->
            <laas-location-cascade-dropdown
              formControlName="searchLocation"
              [showCountry]="true"
              [showCity]="true"
              [showArea]="false"
              [showExpressArea]="false"
              [showDistrict]="false"
              [useMultiSelectForCountry]="false"
              [useMultiSelectForCity]="true"
              [useMultiSelectForArea]="false"
              [useMultiSelectForExpressArea]="false"
              [useMultiSelectForDistrict]="false"
              countryLabel="{{ 'AssignmentDistrictMaintenance.Form.Country' | translate }}"
              cityLabel="{{ 'AssignmentDistrictMaintenance.Form.City' | translate }}"
              countryPlaceholder="{{ 'AssignmentDistrictMaintenance.Placeholder.OptionHint.SelectACountry' | translate }}"
              cityPlaceholder="{{ 'AreaMappingRFQMaintenance.Placeholder.OptionHint.SelectOneOrMoreCity' | translate }}"
              [allowAllOption]="false"
              [showClear]="true"
              [enableFilter]="true"
              [virtualScroll]="true"
              [itemSize]="40"
              [cssClasses]="'col-6 field'"
              (countryOptionsReady)="onCountryOptionsReady($event)"
              (cityOptionsReady)="onCityOptionsReady($event)">
            </laas-location-cascade-dropdown>

            <!-------------------------------------- Priority slot ---------------------------------------------->
            <div class="col-6 field">
              <label for="formPriority">{{ 'AssignmentDistrictMaintenance.Form.Priority' | translate }}</label>
              <input pInputText type="text" maxlength="10" id="formPriority" formControlName="priority"/>
              <small>{{ 'AssignmentDistrictMaintenance.Form.PriorityNote' | translate }}</small>
            </div>

          </div>

          <!-------------------------------------- Form Button ---------------------------------------------->
          <div>

            <!-------------------------------------- Query Button ---------------------------------------------->
            <button
              pButton
              type="submit"
              label="{{ 'Common.Button.Search' | translate }}">
            </button>

            <!-------------------------------------- Reset Button ---------------------------------------------->
            <button
              pButton
              type="reset"
              label="{{ 'Common.Button.Reset' | translate }}"
              class="p-button-secondary ml-2">
            </button>
          </div>

        </form>
      </p-accordionTab>
    </p-accordion>

    <!-------------------------------------- Table ---------------------------------------------->
    <p-table
      #table
      [columns]="selectedColumns"
      [value]="tableData"
      [loading]="isLoading"
      [reorderableColumns]="true"
      [resizableColumns]="true"

      [scrollable]="true"
      scrollHeight="500px"
      scrollDirection="both"

      [(selection)]="selectedRow"
      selectionMode="single"

      [lazy]="true"
      (onPage)="onTablePageChanging($event)"
      (onSort)="onTableSorting($event)"
      [resetPageOnSort]="false"

      [paginator]="true"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
      [rows]="this.pageInfo.pageSize"
      [rowsPerPageOptions]="[5, 10, 20]"
      [totalRecords]="this.pageInfo.totalRecords"

      class="editTable"
      dataKey="dataKey"
      editMode="row"
      styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;">

      <!-------------------------------------- Table Caption Part ---------------------------------------------->
      <ng-template pTemplate="caption">

        <!-------------------------------------- Display Column List ---------------------------------------------->
        <laas-table-column-toggle
          [optionsColumn]="tableColumns"
          [dataTable]="table">
        </laas-table-column-toggle>

        <!-------------------------------------- Add Button ---------------------------------------------->
        <button pButton
          class="p-button-success p-button-raised ml-2"
          label="{{ 'Common.Button.Add' | translate }}"
          icon="fa fa-plus"
          [disabled]="!isInEditMode"
          (click)="addNewRow()"
        ></button>

        <!-------------------------------------- Delete Button ---------------------------------------------->
        <button pButton
          class="p-button-danger p-button-raised ml-2"
          label="{{ 'Common.Button.Delete' | translate }}"
          icon="fas fa-trash-alt"
          [disabled]="!isInEditMode || tableData.length <= 0"
          (click)="deleteSelectedRow()"
        ></button>

        <!-------------------------------------- Save Button ---------------------------------------------->
        <button pButton
          class="p-button-raised ml-2"
          label="{{ 'Common.Button.Save' | translate}}"
          icon="fas fa-save"
          [disabled]="!isInEditMode"
          (click)="saveChanges()"
        ></button>

        <!-------------------------------------- Restore Button ---------------------------------------------->
        <button pButton
          class="p-button-secondary p-button-raised ml-2"
          label="{{ 'AssignmentDistrictMaintenance.Table.Button.Restore' | translate }}"
          icon="fas fa-sync-alt"
          [disabled]="!isInEditMode"
          (click)="restoreTableData()"
        ></button>

        <!-------------------------------------- Edit Button ---------------------------------------------->
        <button pButton
          style="color: white"
          class="p-button-warning p-button-raised ml-2"
          label="{{ isInEditMode ? ( 'Common.Button.Cancel' | translate ) : ( 'Common.Button.Edit' | translate ) }}"
          icon="fas fa-pen"
          (click)="switchEditMode()"
        ></button>

      </ng-template>

      <!-------------------------------------- Table Column Group Part ---------------------------------------------->
      <!---------------------------- Make columns as a group for horizontal scroll ---------------------------------------------->
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" style="width: 14.8vw" />
        </colgroup>
      </ng-template>

      <!-------------------------------------- Table Header Part ---------------------------------------------->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            scope="col">
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <!-------------------------------------- Table Body Part ---------------------------------------------->
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRowSelect(rowData)">
          <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

            <!-------------------------------------- Assignment District ID Column ---------------------------------------------->
            <td *ngSwitchCase="'assignmentDistrictId'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input" >
                  <label for="tableAssignmentDistrictId"></label>
                  <input pInputText required
                    id="tableAssignmentDistrictId"
                    type="text"
                    maxlength="10"
                    [(ngModel)]="rowData[col.field]"
                  />
                  <small *ngIf="!rowData[col.field] || rowData[col.field].trim().length <= 0" class="alert">
                    <div class="p-invalid">
                      {{ 'AssignmentDistrictMaintenance.Table.FieldWarning.AssignmentDistrictIdIsRequired' | translate }}
                    </div>
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-' }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Facility Column ---------------------------------------------->
            <td *ngSwitchCase="'facility'">
              <div class="overflow-text">
                {{rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- Country Column ---------------------------------------------->
            <td *ngSwitchCase="'country'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-dropdown
                    class="p-fluid"
                    appendTo="body"
                    placeholder="{{ 'AssignmentDistrictMaintenance.Placeholder.OptionHint.SelectACountry' | translate }}"
                    (onChange)="tableSelectedCountryChanged($event, rowData)"
                    [filter]="true"
                    [showClear]="true"
                    [options]="countryOptions"
                    [virtualScroll]="true"
                    [itemSize]="40"
                    [(ngModel)]="rowData[col.field]"
                  ></p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping: this.countryOptions | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- City Column ---------------------------------------------->
            <td *ngSwitchCase="'citySeq'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <p-dropdown
                    appendTo="body"
                    inputId="tableCity"
                    placeholder="{{ 'AreaMappingRFQMaintenance.Placeholder.OptionHint.SelectACity' | translate}}"
                    [showClear]="true"
                    [filter]="true"
                    [options]="tableCityOptions"
                    [virtualScroll]="true"
                    [itemSize]="40"
                    [(ngModel)]="rowData['citySeqNo']"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData['citySeqNo'] | optionsMapping: this.tableCityOptions | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- District Name Column ---------------------------------------------->
            <td *ngSwitchCase="'districtName'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <label for="tableDistrictName"></label>
                  <input pInputText required
                    id="tableDistrictName"
                    type="text"
                    maxlength="50"
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-' }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Priority Column ---------------------------------------------->
            <td *ngSwitchCase="'priority'" >
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input" >
                  <label for="tablePriority"></label>
                  <input pInputText required
                    id="tablePriority"
                    type="text"
                    maxlength="10"
                    [(ngModel)]="rowData[col.field]"
                  />
                  <small *ngIf="!checkPriorityIsInRightFormat(rowData[col.field])" class="alert">
                    <div class="p-invalid">
                      {{ 'AssignmentDistrictMaintenance.Table.FieldWarning.PriorityMustBePositiveNumber' | translate }}
                    </div>
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-' }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Create User Column ---------------------------------------------->
            <td *ngSwitchCase="'createUser'">
              <div class="overflow-text">
                {{rowData[col.field] | replaceNullWith:'-'}}
              </div>
            </td>

            <!-------------------------------------- CreateDt Column ---------------------------------------------->
            <td *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{rowData[col.field] | date:'YYYY-MM-dd HH:mm:ss' | replaceNullWith:'-'}}
              </div>
            </td>

            <!-------------------------------------- Update User Column ---------------------------------------------->
            <td *ngSwitchCase="'updateUser'">
              <div class="overflow-text">
                {{rowData[col.field] | replaceNullWith:'-'}}
              </div>
            </td>

            <!-------------------------------------- UpdateDt Column ---------------------------------------------->
            <td *ngSwitchCase="'updateDt'">
              <div class="overflow-text">
                {{rowData[col.field] | date:'YYYY-MM-dd HH:mm:ss' | replaceNullWith:'-'}}
              </div>
            </td>

          </ng-container>
        </tr>
      </ng-template>

      <!-------------------------------------- Table Empty Message Part ---------------------------------------------->
      <!-------------------------------------- Message for empty table ---------------------------------------------->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ "Common.Table.NoData" | translate }}
          </td>
        </tr>
      </ng-template>

    </p-table>
  </p-card>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
